@if (entry.base?.display) {
  <!-- Proxy form - exists to update state from forms-as-json, but does not have any direct interaction -->
  <form [formGroup]="form" [connect]="'payloadStates.' + entry.formControlAttributes.connectPath" class="date-form"></form>
  <!-- Direct interaction form -->
  @if (dateForm) {
    <form [formGroup]="dateForm" class="date-form-proxy">
      <!--Date of Life Event-->
      <mat-form-field appearance="outline" class="event-date">
        <mat-label>{{entry.formControlAttributes?.label || 'Life Event Date'}}</mat-label>
        <!-- @TODO Add constraints & messaging to detail the windows of validity -->
        <input matInput [matDatepicker]="picker1" [formControlName]="entry.formControlAttributes.formControlName" placeholder="MM/DD/YYYY" (dateChange)="dateChanged('change', $event); onDateSelected($event.value)">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        @if (dateFormControls[entry.formControlAttributes.formControlName].errors?.required) {
          <mat-error>{{entry.custom?.dateOfLifeEventRequiredErrorMessage || 'Required'}}</mat-error>
        }
        @if (dateFormControls[(entry.formControlAttributes.formControlName)].errors?.firstOfMonth) {
          <mat-error>{{ entry.custom?.firstOfMonthErrorMessage ? entry.custom?.firstOfMonthErrorMessage : "Dates must be the first of the month." }}</mat-error>
        }
        @if (dateFormControls[(entry.formControlAttributes.formControlName)].errors?.outOfRange) {
          <mat-error>{{ entry.custom?.dateOfLifeEventRangeErrorMessage ? entry.custom?.dateOfLifeEventRangeErrorMessage : "Date is out of range" }}</mat-error>
        }
      </mat-form-field>
    </form>
  }
}